export { default } from "./ContentCard";
